const ZDANIA140 = [
  {
    name: "Słówka (PL/EN) 2026 marzec",
    lang: "en",
    zdania: [
      // TRANSPORT
      { pl: "lotnisko", de: "airport" },
      { pl: "łódź", de: "boat" },
      { pl: "przystanek/dworzec autobusowy", de: "bus stop/station" },
      { pl: "autokar", de: "coach" },
      { pl: "prom", de: "ferry" },
      { pl: "ciężarówka", de: "lorry" },
      { pl: "środki transportu", de: "means of transport" },
      { pl: "motocykl", de: "motorbike" },
      { pl: "pieszo", de: "on foot" },
      { pl: "samolot", de: "plane" },
      { pl: "peron", de: "platform" },
      { pl: "transport publiczny", de: "public transport" },
      { pl: "dworzec kolejowy", de: "railway/train station" },
      { pl: "statek", de: "ship" },
      { pl: "postój taksówek", de: "taxi rank" },
      { pl: "pociąg", de: "train" },
      { pl: "tramwaj", de: "tram" },
      { pl: "metro", de: "underground/tube (BrE)/subway (AmE)" },
      { pl: "stacja metra", de: "underground/tube station" },

      // PODRÓŻOWANIE
      { pl: "wypadek", de: "accident" },
      { pl: "przybycie, przyjazd", de: "arrival" },
      { pl: "przybyć/przyjechać do (miasta/kraju)", de: "arrive in (a city/country)" },
      { pl: "przybyć, przyjechać na/do (stację/kina)", de: "arrive at (a station/cinema)" },
      { pl: "odbiór bagażu", de: "baggage reclaim" },
      { pl: "wchodzić na pokład", de: "board" },
      { pl: "karta pokładowa", de: "boarding card" },
      { pl: "zarezerwować lot", de: "book a flight" },
      { pl: "przesiadać się", de: "change (trains/planes/buses)" },
      { pl: "stanowisko odprawy, recepcja", de: "check-in desk" },
      { pl: "rejs wycieczkowy", de: "cruise" },
      { pl: "opóźniony", de: "delayed" },
      { pl: "odjeżdżać, odlatywać", de: "depart" },
      { pl: "odjazd, odlot", de: "departure" },
      { pl: "cel podróży", de: "destination" },
      { pl: "prowadzić samochód", de: "drive" },
      { pl: "sklep wolnocłowy", de: "duty-free shop" },
      { pl: "nagły wypadek, sytuacja kryzysowa, awaria", de: "emergency" },
      { pl: "wycieczka", de: "excursion" },
      { pl: "zapinać pasy", de: "fasten your seat belts" },
      { pl: "lot", de: "flight" },
      { pl: "steward/stewardesa", de: "flight attendant" },
      { pl: "numer lotu", de: "flight number" },
      { pl: "lecieć", de: "fly" },
      { pl: "wyjście (do samolotu)", de: "gate" },
      { pl: "wyjechać za granicę", de: "go abroad" },
      { pl: "bagaż (podręczny)", de: "(hand) luggage/baggage" },
      { pl: "jazda autostopem", de: "hitchhiking" },
      { pl: "podróż", de: "journey" },
      { pl: "lądować", de: "land" },
      { pl: "odjeżdżać, wychodzić, zostawiać", de: "leave" },
      { pl: "zgubić bagaż", de: "lose one's luggage" },
      { pl: "zrobić rezerwację", de: "make a reservation" },
      { pl: "spóźnić się na autobus/pociąg", de: "miss the bus/train" },
      { pl: "na pokładzie", de: "on board" },
      { pl: "pakować", de: "pack" },
      { pl: "pasażer/pasażerka", de: "passenger" },
      { pl: "paszport", de: "passport" },
      { pl: "wycieczka szkolna", de: "school trip" },
      { pl: "miejsce (przy przejściu/oknie)", de: "(aisle/window) seat" },
      { pl: "wycieczka objazdowa", de: "sightseeing tour" },
      { pl: "bilet w jedną stronę / w obie strony", de: "single/return ticket" },
      { pl: "pojechać pociągiem/polecieć samolotem", de: "take a train/plane/flight" },
      { pl: "kasa biletowa", de: "ticket office" },
      { pl: "rozkład jazdy", de: "timetable" },
      { pl: "turysta/turystka", de: "tourist" },
      { pl: "biuro podróży", de: "travel agent's" },
      { pl: "podróżować dookoła świata", de: "travel around the world" },
      { pl: "podróżować autobusem/pociągiem/samolotem", de: "travel by coach/train/plane" },
      { pl: "kupon, talon", de: "voucher" },
      { pl: "podróż morska", de: "voyage" },

      // ZAKWATEROWANIE
      { pl: "zakwaterowanie", de: "accommodation" },
      { pl: "pokoje gościnne (nocleg i śniadanie)", de: "B&B (bed and breakfast)" },
      { pl: "samochód kempingowy", de: "camper" },
      { pl: "pole namiotowe, kemping", de: "campsite" },
      { pl: "przyczepa kempingowa", de: "caravan" },
      { pl: "gość", de: "guest" },
      { pl: "pensjonat", de: "guesthouse" },
      { pl: "schronisko górskie", de: "mountain shelter" },
      { pl: "recepcjonista/recepcjonistka", de: "receptionist" },
      { pl: "pokój jednosobowy/dwuosobowy", de: "single/double room" },
      { pl: "namiot", de: "tent" },
      { pl: "schronisko młodzieżowe", de: "youth hostel" },

      // EKWIPUNEK
      { pl: "ładowarka", de: "charger" },
      { pl: "leżak", de: "deckchair" },
      { pl: "przewodnik", de: "guidebook" },
      { pl: "zapałki", de: "matches" },
      { pl: "płaszcz przeciwdeszczowy", de: "raincoat" },
      { pl: "plecak", de: "rucksack/backpack" },
      { pl: "narty", de: "skis" },
      { pl: "śpiwór", de: "sleeping bag" },
      { pl: "walizka", de: "suitcase" },
      { pl: "krem do opalania", de: "sun cream" },
      { pl: "okulary przeciwsłoneczne", de: "sunglasses" },
      { pl: "kostium kąpielowy", de: "swimsuit" },
      { pl: "kąpielówki", de: "swimming trunks" },
      { pl: "latarka", de: "torch" },

      // WAKACJE – RODZAJE
      { pl: "wędrówka z plecakiem", de: "backpacking" },
      { pl: "turysta wędrujący z plecakiem", de: "backpacker" },
      { pl: "wycieczka jednodniowa", de: "day out" },
      { pl: "pojechać pod namiot", de: "go camping" },
      { pl: "pojechać nad morze / w góry", de: "go to the seaside/mountains" },
      { pl: "zwiedzać", de: "go sightseeing" },
      { pl: "wakacje zorganizowane", de: "package holiday" },
      { pl: "obóz (sportowy)", de: "(sports) camp" },
      { pl: "ferie zimowe", de: "winter holiday" },

      // MIEJSCA, CZYNNOŚCI, ATRAKCJE
      { pl: "plaża", de: "beach" },
      { pl: "piękne widoki", de: "beautiful views" },
      { pl: "zbudować zamek z piasku", de: "build a sandcastle" },
      { pl: "ognisko na biwaku", de: "campfire" },
      { pl: "pływanie kajakiem", de: "canoeing" },
      { pl: "zamek", de: "castle" },
      { pl: "wspinać się", de: "climb" },
      { pl: "loch", de: "dungeon" },
      { pl: "wystawa", de: "exhibition" },
      { pl: "zwiedzać ciekawe miejsca", de: "explore the sights" },
      { pl: "wesołe miasteczko", de: "funfair" },
      { pl: "przegryźć coś, zjeść niewielki posiłek", de: "have a bite" },
      { pl: "piesze wycieczki, wędrówki", de: "hiking" },
      { pl: "wynająć (rower)", de: "hire (a bike)" },
      { pl: "rozpalić ognisko", de: "make a fire" },
      { pl: "główny plac", de: "main square" },
      { pl: "muzeum", de: "museum" },
      { pl: "ciekawe miejsce", de: "place of interest" },
      { pl: "pocztówka", de: "postcard" },
      { pl: "kolejka; stać w kolejce", de: "queue" },
      { pl: "jeździć (np. rowerem/kolejką górską); jazda, przejażdżka", de: "ride" },
      { pl: "kolejka górska", de: "roller coaster" },
      { pl: "żeglować", de: "sail" },
      { pl: "piasek", de: "sand" },
      { pl: "jeździć na nartach", de: "ski" },
      { pl: "impreza z noclegiem, nocowanie", de: "sleepover" },
      { pl: "nurkowanie z rurką", de: "snorkelling" },
      { pl: "jazda na snowboardzie", de: "snowboarding" },
      { pl: "pamiątka", de: "souvenir" },
      { pl: "opalać się", de: "sunbathe" },
      { pl: "robić zdjęcia", de: "take photos" },
      { pl: "park rozrywki", de: "theme park" },
      { pl: "atrakcja turystyczna", de: "tourist attraction" },
      { pl: "biuro informacji turystycznej", de: "tourist information office" },
      { pl: "odwiedzać", de: "visit" },

      // WSKAZYWANIE DROGI
      { pl: "pytać o / wskazywać komuś drogę", de: "ask/show sb the way" },
      { pl: "przejść przez ulicę", de: "cross the street" },
      { pl: "zgubić się, zabłądzić", de: "get lost" },
      { pl: "iść wzdłuż ulicy", de: "go along/down a street" },
      { pl: "przejść obok czegoś, mijać coś", de: "go past sth" },
      { pl: "iść prosto", de: "go straight (on)" },
      { pl: "na rogu", de: "on the corner" },
      { pl: "po prawej/lewej stronie", de: "on the/your right/left" },
      { pl: "naprzeciwko", de: "opposite" },
      { pl: "skręcić w (pierwszą) przecznicę po prawej stronie", de: "take the (first) turning on the right" },
      { pl: "skręcać w prawo/lewo w (ulicę)", de: "turn right/left into" },

      // CZASOWNIKI ZŁOŻONE
      { pl: "zepsuć się (o pojeździe)", de: "break down" },
      { pl: "przejść odprawę biletową (na lotnisku / przez internet)", de: "check in (at the airport/online)" },
      { pl: "zameldować się / wymeldować się (w/z hotelu)", de: "check in/out (at the hotel)" },
      { pl: "wsiąść do samochodu / wysiąść z samochodu", de: "get into / out of a car" },
      { pl: "wsiąść do / wysiąść z pociągu/autobusu", de: "get on/off a train/bus" },
      { pl: "wyjechać na wakacje", de: "go away on holiday" },
      { pl: "podjechać po kogoś", de: "pick sb up" },
      { pl: "rozbić namiot", de: "put up a tent" },
      { pl: "(o benzynie) skończyć się", de: "run out of (petrol)" },
      { pl: "wyruszyć", de: "set off/out" },
      { pl: "zwolnić", de: "slow down" },
      { pl: "wystartować (o samolocie)", de: "take off" }
    ]
  }
];


const ZDANIA150 = [
  {
    name: "Żywność i napoje",
    lang: "en",
    zdania: [
      // WARZYWA I OWOCE
      { pl: "awokado", de: "avocado" },
      { pl: "fasola", de: "beans" },
      { pl: "kapusta", de: "cabbage" },
      { pl: "marchewka", de: "carrot" },
      { pl: "wiśnia", de: "cherry" },
      { pl: "szczypiorek", de: "chives" },
      { pl: "ogórek", de: "cucumber" },
      { pl: "czosnek", de: "garlic" },
      { pl: "winogrona", de: "grapes" },
      { pl: "groszek", de: "(green) peas" },
      { pl: "zielona/czerwona papryka", de: "(green/red) pepper" },
      { pl: "cytryna", de: "lemon" },
      { pl: "sałata", de: "lettuce" },
      { pl: "grzyby", de: "mushrooms" },
      { pl: "cebula", de: "onion" },
      { pl: "brzoskwinia", de: "peach" },
      { pl: "gruszka", de: "pear" },
      { pl: "ananas", de: "pineapple" },
      { pl: "śliwka", de: "plum" },
      { pl: "ziemniak", de: "potato" },
      { pl: "truskawka", de: "strawberry" },
      { pl: "kukurydza", de: "sweetcorn" },
      { pl: "pomidor", de: "tomato" },
      { pl: "arbuz", de: "watermelon" },

      // MIĘSO I RYBY
      { pl: "wołowina", de: "beef" },
      { pl: "kurczak", de: "chicken" },
      { pl: "wędliny", de: "cold meats" },
      { pl: "szynka", de: "ham" },
      { pl: "śledź", de: "herring" },
      { pl: "jagnięcina", de: "lamb" },
      { pl: "wieprzowina", de: "pork" },
      { pl: "łosoś", de: "salmon" },
      { pl: "kiełbasa", de: "sausage" },
      { pl: "owoce morza", de: "seafood" },
      { pl: "stek", de: "(rare/medium/well-done) steak" },
      { pl: "tuńczyk", de: "tuna" },
      { pl: "indyk", de: "turkey" },

      // PRODUKTY ZBOŻOWE
      { pl: "chleb razowy/pełnoziarnisty", de: "(brown/wholemeal) bread" },
      { pl: "płatki śniadaniowe", de: "breakfast cereal" },
      { pl: "słodka bułka", de: "bun" },
      { pl: "mąka", de: "flour" },
      { pl: "kluski, makaron", de: "noodles" },
      { pl: "makaron", de: "pasta" },
      { pl: "ryż", de: "rice" },
      { pl: "bułka", de: "roll" },
      { pl: "pieczywo tostowe", de: "toast bread" },

      // SKŁADNIKI ODŻYWCZE
      { pl: "węglowodany złożone", de: "(complex) carbohydrates" },
      { pl: "tłuszcze", de: "fats" },
      { pl: "białka", de: "proteins" },

      // NAPOJE
      { pl: "napój gazowany/bezalkoholowy", de: "fizzy/soft drink" },
      { pl: "sok", de: "juice" },
      { pl: "woda mineralna gazowana/niegazowana", de: "(sparkling/still) mineral water" },

      // PRODUKTY MLECZNE
      { pl: "masło", de: "butter" },
      { pl: "ser", de: "cheese" },
      { pl: "twarożek", de: "cottage cheese" },
      { pl: "śmietana", de: "cream" },
      { pl: "jogurt", de: "yoghurt" },

      // SŁODYCZE
      { pl: "szarlotka", de: "apple pie" },
      { pl: "herbatnik, ciasteczko", de: "biscuit/cookie" },
      { pl: "ciasto czekoladowe", de: "(chocolate) cake" },
      { pl: "sernik", de: "cheesecake" },
      { pl: "pączek", de: "doughnut" },
      { pl: "lody", de: "ice cream" },
      { pl: "makowiec", de: "poppyseed cake" },
      { pl: "jedzenie zawierające dużo cukru", de: "sugary things" },

      // INNE PRODUKTY
      { pl: "chipsy, chrupki", de: "crisps" },
      { pl: "jajko", de: "egg" },
      { pl: "miód", de: "honey" },
      { pl: "dżem", de: "jam" },
      { pl: "orzech", de: "nut" },
      { pl: "oliwa z oliwek", de: "olive oil" },
      { pl: "orzeszki ziemne", de: "peanuts" },
      { pl: "pieprz", de: "pepper" },
      { pl: "przyprawa", de: "spice" },
      { pl: "przecier pomidorowy", de: "tomato sauce" },
      { pl: "olej roślinny", de: "(vegetable) oil" },
      { pl: "ocet", de: "vinegar" },

      // POTRAWY
      { pl: "barszcz czerwony", de: "beetroot soup" },
      { pl: "jajko gotowane na twardo/miękko", de: "(hard-/soft-) boiled egg" },
      { pl: "rosół", de: "chicken soup" },
      { pl: "skrzydełka z kurczaka", de: "chicken wings" },
      { pl: "frytki", de: "chips/French fries" },
      { pl: "sos do sałatki", de: "dressing" },
      { pl: "pierogi", de: "dumplings" },
      { pl: "nadzienie", de: "filling" },
      { pl: "paluszki rybne", de: "fish fingers" },
      { pl: "jajko sadzone", de: "fried egg" },
      { pl: "bigos", de: "hunter’s stew" },
      { pl: "zupa grzybowa", de: "mushroom soup" },
      { pl: "omlet z szynką", de: "(ham) omelette" },
      { pl: "naleśnik", de: "pancake" },
      { pl: "zapiekanka", de: "pie" },
      { pl: "sałatka", de: "salad" },
      { pl: "kanapka", de: "sandwich" },
      { pl: "kotlet schabowy", de: "schnitzel" },
      { pl: "jajecznica", de: "scrambled egg" },
      { pl: "zupa pomidorowa", de: "tomato soup" },

      // OPAKOWANIA I ILOŚĆ
      { pl: "torebka mąki", de: "a bag of flour" },
      { pl: "tabliczka czekolady mlecznej", de: "a bar of milk chocolate" },
      { pl: "butelka wody", de: "a bottle of water" },
      { pl: "pudełko czekoladek", de: "a box of chocolates" },
      { pl: "puszka lemoniady", de: "a can of lemonade" },
      { pl: "karton soku pomarańczowego", de: "a carton of orange juice" },
      { pl: "ząbek czosnku", de: "a clove of garlic" },
      { pl: "filiżanka herbaty", de: "a cup of tea" },
      { pl: "szklanka wody", de: "a glass of water" },
      { pl: "słoik dżemu", de: "a jar of jam" },
      { pl: "bochenek chleba", de: "a loaf of bread" },
      { pl: "paczka płatków śniadaniowych", de: "a packet of breakfast cereal" },
      { pl: "szczypta soli", de: "a pinch of salt" },
      { pl: "łyżka/łyżeczka miodu", de: "a tablespoon/teaspoon of honey" },
      { pl: "puszka zielonego groszku", de: "a tin of green peas" },

      // PRZY STOLE
      { pl: "miska", de: "bowl" },
      { pl: "filiżanka", de: "cup" },
      { pl: "sztućce", de: "cutlery" },
      { pl: "widelec", de: "fork" },
      { pl: "szklanka", de: "glass" },
      { pl: "nóż", de: "knife" },
      { pl: "kubek", de: "mug" },
      { pl: "serwetka", de: "napkin" },
      { pl: "talerz", de: "plate" },
      { pl: "łyżka", de: "spoon" },
      { pl: "obrus", de: "tablecloth" },

      // PRZYMIOTNIKI
      { pl: "gorzki", de: "bitter" },
      { pl: "mdły", de: "bland" },
      { pl: "wyśmienity", de: "delicious" },
      { pl: "obrzydliwy", de: "disgusting" },
      { pl: "tuczący", de: "fattening" },
      { pl: "świeży", de: "fresh" },
      { pl: "tłusty", de: "greasy" },
      { pl: "zdrowy/niezdrowy", de: "(un)healthy" },
      { pl: "domowy", de: "homemade" },
      { pl: "łagodny", de: "mild" },
      { pl: "odżywczy", de: "nutritious" },
      { pl: "słony", de: "salty" },
      { pl: "kwaśny", de: "sour" },
      { pl: "ostry, pikantny", de: "spicy/hot" },
      { pl: "czerstwy", de: "stale" },
      { pl: "słodki", de: "sweet" },
      { pl: "smaczny", de: "tasty" },
      { pl: "wegetariański", de: "vegetarian" },
      { pl: "pyszny", de: "yummy" }
    ]
  }
];

const ZDANIA151 = [
  {
    name: "Przygotowywanie potraw i restauracja",
    lang: "en",
    zdania: [
      // PRZYGOTOWYWANIE POTRAW
      { pl: "dodać", de: "add" },
      { pl: "piec (ciasto lub chleb)", de: "bake" },
      { pl: "grillować, piec na grillu", de: "barbecue" },
      { pl: "ubić", de: "beat/whisk" },
      { pl: "zagotować", de: "boil" },
      { pl: "bulion", de: "broth" },
      { pl: "siekać", de: "chop" },
      { pl: "obtoczyć coś w czymś", de: "coat sth with sth" },
      { pl: "kuchnia (sposób gotowania)", de: "cuisine" },
      { pl: "kroić", de: "cut" },
      { pl: "ciasto (np. na pierogi)", de: "dough" },
      { pl: "smażyć", de: "fry" },
      { pl: "patelnia", de: "frying pan" },
      { pl: "trzeć na tarce", de: "grate" },
      { pl: "podgrzać", de: "heat" },
      { pl: "składnik", de: "ingredient" },
      { pl: "czajnik", de: "kettle" },
      { pl: "utłuc (ziemniaki)", de: "mash" },
      { pl: "topić, rozpuszczać", de: "melt" },
      { pl: "mieszać (kilka składników)", de: "mix" },
      { pl: "masa, mieszanina", de: "mixture" },
      { pl: "piekarnik", de: "oven" },
      { pl: "obierać", de: "peel" },
      { pl: "porcja", de: "portion" },
      { pl: "garnek", de: "pot" },
      { pl: "nalewać", de: "pour" },
      { pl: "przepis", de: "recipe" },
      { pl: "piec (mięso lub warzywa)", de: "roast" },
      { pl: "rozwałkować", de: "roll" },
      { pl: "podawać", de: "serve" },
      { pl: "ciąć na plasterki; plasterek, kromka", de: "slice" },
      { pl: "mieszać (jedną substancję)", de: "stir" },

      // W RESTAURACJI
      { pl: "rachunek", de: "bill" },
      { pl: "zarezerwować stolik", de: "book a table" },
      { pl: "kawiarnia", de: "café / coffee shop" },
      { pl: "deser", de: "dessert" },
      { pl: "bar szybkiej obsługi", de: "fast-food restaurant/bar" },
      { pl: "danie główne", de: "main course" },
      { pl: "w karcie dań", de: "on the menu" },
      { pl: "zamówić, zamówienie", de: "order" },
      { pl: "bar samoobsługowy", de: "self-service restaurant" },
      { pl: "przystawka", de: "starter" },
      { pl: "jedzenie na wynos", de: "takeaway" },

      // INNE
      { pl: "spalać (kalorie)", de: "burn off (calories)" },
      { pl: "przypływ energii", de: "burst of energy" },
      { pl: "Czy mogę dostać…?", de: "Can I have ...?" },
      { pl: "jeść w domu", de: "eat in" },
      { pl: "jeść na mieście", de: "eat out" },
      { pl: "(nie)jadalny", de: "(in)edible" },
      { pl: "wyszukany", de: "fancy" },
      { pl: "Smacznego.", de: "Enjoy your meal." },
      { pl: "mieć ochotę", de: "feel like" },
      { pl: "osoba wybredna, grymaśna co do jedzenia", de: "fussy eater" },
      { pl: "wybierać", de: "go for" },
      { pl: "przejść na dietę", de: "go on a diet" },
      { pl: "zjeść coś na szybko", de: "grab something to eat" },
      { pl: "jeść posiłek", de: "have a meal" },
      { pl: "Częstuj się.", de: "Help yourself." },
      { pl: "trafiony/dobry lub nietrafiony/zły", de: "hit-or-miss" },
      { pl: "Prawie nie jem…", de: "I hardly eat ..." },
      { pl: "niezdrowe jedzenie", de: "junk food" },
      { pl: "nakryć do stołu", de: "lay the table" },
      { pl: "stracić/przybrać na wadze", de: "lose / put on weight" },
      { pl: "specjalista żywieniowy", de: "nutrition expert" },
      { pl: "podać", de: "pass" },
      { pl: "słodzić herbatę", de: "take sugar in your tea" }
    ]
  }
];

const ZDANIA152 = [
  {
    name: "maj 2026 - Unit 2 Vocabulary – Travel and transport",
    lang: "en",
    zdania: [
      { pl: "podróż morska, rejs", de: "voyage" },
      { pl: "podróż", de: "journey" },
      { pl: "wycieczka, krótka podróż", de: "trip" },
      { pl: "podróżowanie, podróże", de: "travel" },
      { pl: "wycieczka", de: "excursion" },
      { pl: "widok", de: "view" },
      { pl: "widok, zabytek, atrakcja", de: "sight" },
      { pl: "świat", de: "world" },
      { pl: "Ziemia", de: "earth" },
      { pl: "obszar, teren", de: "area" },
      { pl: "terytorium", de: "territory" },
      { pl: "pora roku, sezon", de: "season" },
      { pl: "okres", de: "period" },
      { pl: "opłata za przejazd", de: "fare" },
      { pl: "bilet", de: "ticket" },
      { pl: "opłata", de: "fee" },
      { pl: "spóźnić się na, przegapić", de: "miss" },
      { pl: "zgubić, stracić", de: "lose" },
      { pl: "wziąć, zabrać", de: "take" },
      { pl: "przynieść, przyprowadzić", de: "bring" },
      { pl: "iść, jechać", de: "go" },
      { pl: "rezerwować", de: "book" },
      { pl: "trzymać, zachować", de: "keep" },
      { pl: "przybyć, przyjechać", de: "arrive" },
      { pl: "dotrzeć do, osiągnąć", de: "reach" },
      { pl: "mieszkać, żyć", de: "live" },
      { pl: "zatrzymać się, zostać", de: "stay" },
      { pl: "granica", de: "border" },
      { pl: "krawędź, brzeg", de: "edge" },
      { pl: "linia", de: "line" },
      { pl: "długość", de: "length" },
      { pl: "odległość", de: "distance" },
      { pl: "przewodnik; prowadzić", de: "guide" },
      { pl: "prowadzić", de: "lead" },
      { pl: "rodzimy, ojczysty; tubylec", de: "native" },
      { pl: "dom, ojczyzna", de: "home" },

      { pl: "dogonić; nadrobić zaległości", de: "catch up with" },
      { pl: "zameldować się; odprawić się", de: "check in" },
      { pl: "wymeldować się; sprawdzić, zbadać", de: "check out" },
      { pl: "wysadzić kogoś z pojazdu; zasnąć", de: "drop off" },
      { pl: "wrócić z jakiegoś miejsca", de: "get back" },
      { pl: "wyjechać na wakacje", de: "go away" },
      { pl: "nadążać za kimś/czymś", de: "keep up with" },
      { pl: "kierować się w stronę", de: "make for" },
      { pl: "zatrzymać się, żeby kogoś zabrać", de: "pick up" },
      { pl: "zjechać na pobocze i zatrzymać się", de: "pull in" },
      { pl: "potrącić, przejechać samochodem", de: "run over" },
      { pl: "odprowadzić kogoś, pożegnać przed podróżą", de: "see off" },
      { pl: "wyruszyć w podróż", de: "set out/off" },
      { pl: "wystartować, oderwać się od ziemi", de: "take off" },
      { pl: "zawrócić", de: "turn round" },

      { pl: "mieć wypadek", de: "have an accident" },
      { pl: "brać udział w wypadku", de: "be involved in an accident" },
      { pl: "zrobić coś przypadkiem", de: "do sth by accident" },
      { pl: "z wyprzedzeniem", de: "in advance" },
      { pl: "posuwać się do przodu / w stronę jakiegoś miejsca", de: "advance to/towards a place" },
      { pl: "iść prosto przed siebie", de: "go straight ahead" },
      { pl: "śmiało, proszę bardzo", de: "go ahead" },
      { pl: "być przed kimś/czymś", de: "be ahead of sth/sb" },
      { pl: "zmiana kierunku", de: "a change of direction" },
      { pl: "w kierunku czegoś", de: "in the direction of sth" },
      { pl: "w tym/tamtym kierunku", de: "in this/that direction" },
      { pl: "z głowy, bez zastanowienia", de: "off the top of your head" },
      { pl: "kierować się do/w stronę miejsca", de: "head for/towards a place" },
      { pl: "po uszy zakochany", de: "head over heels in love" },
      { pl: "pojechać/być na wakacjach", de: "go/be on holiday" },
      { pl: "mieć/wziąć urlop", de: "have/take a holiday" },
      { pl: "święto państwowe, dzień wolny od pracy", de: "bank holiday" },
      { pl: "iść/skręcić w lewo", de: "go/turn left" },
      { pl: "po lewej stronie", de: "on the left" },
      { pl: "po lewej stronie", de: "on the left-hand side" },
      { pl: "w lewym rogu", de: "in the left-hand corner" },
      { pl: "leworęczny", de: "left-handed" },
      { pl: "zaplanować trasę", de: "plan your/a route" },
      { pl: "wybrać trasę", de: "take a route" },
      { pl: "zwiedzać zabytki/atrakcje", de: "see the sights" },
      { pl: "zwiedzać", de: "go sightseeing" },
      { pl: "z dużą/pełną prędkością", de: "at high/full speed" },
      { pl: "nagły przypływ prędkości", de: "burst of speed" },
      { pl: "ograniczenie prędkości", de: "speed limit" },
      { pl: "wybrać się na wycieczkę po/około jakiegoś miejsca", de: "go on/take a tour of/around somewhere" },
      { pl: "zwiedzać jakieś miejsce", de: "tour a place" },
      { pl: "przewodnik wycieczki", de: "tour guide" },
      { pl: "podróż służbowa", de: "business trip" },
      { pl: "wycieczka szkolna", de: "school trip" },
      { pl: "pojechać na wycieczkę", de: "go on a trip" },
      { pl: "wybrać się w podróż/na wycieczkę do miejsca", de: "take a trip to a place" },
      { pl: "zgubić drogę", de: "lose your way" },
      { pl: "przedzierać się, iść z trudem", de: "make your way" },
      { pl: "znaleźć drogę", de: "find your way" },
      { pl: "w pewien sposób", de: "in a way" },
      { pl: "w drodze", de: "on the way" },
      { pl: "iść/jechać całą drogę do czegoś/gdzieś", de: "go all the way to sth/swh" },

      { pl: "bać się czegoś/kogoś/robienia czegoś", de: "afraid of sth/sb/doing" },
      { pl: "bać się coś zrobić", de: "afraid to do" },
      { pl: "wydawać się być", de: "appear to be" },
      { pl: "ustalić/zorganizować coś z kimś", de: "arrange sth with sb" },
      { pl: "załatwić, żeby ktoś coś zrobił", de: "arrange for sb to do" },
      { pl: "przybyć do miejsca", de: "arrive in/at a place" },
      { pl: "przybyć tutaj/tam", de: "arrive here/there" },
      { pl: "kontynuować coś/robienie czegoś", de: "continue sth/doing" },
      { pl: "kontynuować robienie czegoś", de: "continue to do" },
      { pl: "kontynuować coś", de: "continue with sth" },
      { pl: "różnić się od czegoś/kogoś", de: "differ from sth/sb" },
      { pl: "marzyć/śnić o czymś/kimś/robieniu czegoś", de: "dream about/of sth/sb/doing" },
      { pl: "zaprosić kogoś, żeby coś zrobił", de: "invite sb to do" },
      { pl: "bardzo chcieć coś zrobić", de: "keen to do" },
      { pl: "lubić coś/kogoś/robienie czegoś", de: "keen on sth/sb/doing" },
      { pl: "mieszkać w/na jakimś miejscu", de: "live in/at a place" },
      { pl: "żyć z czegoś/dla czegoś", de: "live on/for sth" },
      { pl: "mieszkać tutaj/tam", de: "live here/there" },
      { pl: "żałować, że się coś zrobiło/nie zrobiło", de: "regret (not) doing" },
      { pl: "żałować czegoś", de: "regret sth" },
      { pl: "z przykrością informować", de: "regret to tell/inform you" },
      { pl: "myśleć o czymś/kimś/robieniu czegoś", de: "think of/about sth/sb/doing" },
      { pl: "pisać o czymś/kimś/robieniu czegoś", de: "write about sth/sb/doing" },
      { pl: "napisać coś do kogoś", de: "write sth to sb" },
      { pl: "napisać komuś coś", de: "write sb sth" },
      { pl: "zapisać coś", de: "write sth down" },

      { pl: "organizować, ustalać", de: "arrange" },
      { pl: "przearanżować, zmienić układ", de: "rearrange" },
      { pl: "ustalenie, organizacja", de: "arrangement" },
      { pl: "przybyć, przyjechać", de: "arrive" },
      { pl: "przybycie, przyjazd", de: "arrival" },
      { pl: "szeroki", de: "broad" },
      { pl: "szerokość", de: "breadth" },
      { pl: "poszerzać", de: "broaden" },
      { pl: "kultura", de: "culture" },
      { pl: "kulturowy", de: "cultural" },
      { pl: "kulturowo", de: "culturally" },
      { pl: "niekulturalny / pozbawiony kultury", de: "uncultured" },
      { pl: "różnić się", de: "differ" },
      { pl: "różny, inny", de: "different" },
      { pl: "inaczej, różnie", de: "differently" },
      { pl: "różnica", de: "difference" },
      { pl: "bezpośredni; kierować", de: "direct" },
      { pl: "pośredni", de: "indirect" },
      { pl: "kierunek", de: "direction" },
      { pl: "dyrektor, reżyser", de: "director" },
      { pl: "bezpośrednio", de: "directly" },
      { pl: "pośrednio", de: "indirectly" },
      { pl: "odległy", de: "distant" },
      { pl: "z daleka, chłodno", de: "distantly" },
      { pl: "odległość", de: "distance" },
      { pl: "wchodzić", de: "enter" },
      { pl: "wejście", de: "entrance" },
      { pl: "zamieszkiwać", de: "inhabit" },
      { pl: "mieszkaniec", de: "inhabitant" },
      { pl: "fotografia, zdjęcie", de: "photograph" },
      { pl: "fotografia", de: "photography" },
      { pl: "fotograf", de: "photographer" },
      { pl: "fotograficzny", de: "photographic" },
      { pl: "rozpoznawać, uznawać", de: "recognise" },
      { pl: "rozpoznawalny", de: "recognisable" },
      { pl: "nierozpoznawalny", de: "unrecognisable" },
      { pl: "rozpoznanie, uznanie", de: "recognition" },
      { pl: "czas", de: "time" },
      { pl: "rozkład jazdy", de: "timetable" },
      { pl: "wycieczka, zwiedzać", de: "tour" },
      { pl: "turystyka", de: "tourism" },
      { pl: "turysta", de: "tourist" },
      { pl: "świat", de: "world" },
      { pl: "na całym świecie, światowy", de: "worldwide" }
    ]
  }
];


const ZDANIA153 = [
  {
    name: "USA – States and capitals",
    lang: "en",
    zdania: [
      { pl: "Alabama", de: "Montgomery" },
      { pl: "Alaska", de: "Juneau" },
      { pl: "Arizona", de: "Phoenix" },
      { pl: "Arkansas", de: "Little Rock" },
      { pl: "California", de: "Sacramento" },
      { pl: "Colorado", de: "Denver" },
      { pl: "Connecticut", de: "Hartford" },
      { pl: "Delaware", de: "Dover" },
      { pl: "Florida", de: "Tallahassee" },
      { pl: "Georgia", de: "Atlanta" },
      { pl: "Hawaii", de: "Honolulu" },
      { pl: "Idaho", de: "Boise" },
      { pl: "Illinois", de: "Springfield" },
      { pl: "Indiana", de: "Indianapolis" },
      { pl: "Iowa", de: "Des Moines" },
      { pl: "Kansas", de: "Topeka" },
      { pl: "Kentucky", de: "Frankfort" },
      { pl: "Louisiana", de: "Baton Rouge" },
      { pl: "Maine", de: "Augusta" },
      { pl: "Maryland", de: "Annapolis" },
      { pl: "Massachusetts", de: "Boston" },
      { pl: "Michigan", de: "Lansing" },
      { pl: "Minnesota", de: "Saint Paul" },
      { pl: "Mississippi", de: "Jackson" },
      { pl: "Missouri", de: "Jefferson City" },
      { pl: "Montana", de: "Helena" },
      { pl: "Nebraska", de: "Lincoln" },
      { pl: "Nevada", de: "Carson City" },
      { pl: "New Hampshire", de: "Concord" },
      { pl: "New Jersey", de: "Trenton" },
      { pl: "New Mexico", de: "Santa Fe" },
      { pl: "New York", de: "Albany" },
      { pl: "North Carolina", de: "Raleigh" },
      { pl: "North Dakota", de: "Bismarck" },
      { pl: "Ohio", de: "Columbus" },
      { pl: "Oklahoma", de: "Oklahoma City" },
      { pl: "Oregon", de: "Salem" },
      { pl: "Pennsylvania", de: "Harrisburg" },
      { pl: "Rhode Island", de: "Providence" },
      { pl: "South Carolina", de: "Columbia" },
      { pl: "South Dakota", de: "Pierre" },
      { pl: "Tennessee", de: "Nashville" },
      { pl: "Texas", de: "Austin" },
      { pl: "Utah", de: "Salt Lake City" },
      { pl: "Vermont", de: "Montpelier" },
      { pl: "Virginia", de: "Richmond" },
      { pl: "Washington", de: "Olympia" },
      { pl: "West Virginia", de: "Charleston" },
      { pl: "Wisconsin", de: "Madison" },
      { pl: "Wyoming", de: "Cheyenne" }
    ]
  }
];

const ZDANIA153_1 = [
  {
    name: "USA – States and capitals – Part 1",
    lang: "en",
    zdania: [
      { pl: "Alabama", de: "Montgomery" },
      { pl: "Alaska", de: "Juneau" },
      { pl: "Arizona", de: "Phoenix" },
      { pl: "Arkansas", de: "Little Rock" },
      { pl: "California", de: "Sacramento" },
      { pl: "Colorado", de: "Denver" },
      { pl: "Connecticut", de: "Hartford" },
      { pl: "Delaware", de: "Dover" },
      { pl: "Florida", de: "Tallahassee" },
      { pl: "Georgia", de: "Atlanta" }
    ]
  }
];

const ZDANIA153_2 = [
  {
    name: "USA – States and capitals – Part 2",
    lang: "en",
    zdania: [
      { pl: "Hawaii", de: "Honolulu" },
      { pl: "Idaho", de: "Boise" },
      { pl: "Illinois", de: "Springfield" },
      { pl: "Indiana", de: "Indianapolis" },
      { pl: "Iowa", de: "Des Moines" },
      { pl: "Kansas", de: "Topeka" },
      { pl: "Kentucky", de: "Frankfort" },
      { pl: "Louisiana", de: "Baton Rouge" },
      { pl: "Maine", de: "Augusta" },
      { pl: "Maryland", de: "Annapolis" }
    ]
  }
];

const ZDANIA153_3 = [
  {
    name: "USA – States and capitals – Part 3",
    lang: "en",
    zdania: [
      { pl: "Massachusetts", de: "Boston" },
      { pl: "Michigan", de: "Lansing" },
      { pl: "Minnesota", de: "Saint Paul" },
      { pl: "Mississippi", de: "Jackson" },
      { pl: "Missouri", de: "Jefferson City" },
      { pl: "Montana", de: "Helena" },
      { pl: "Nebraska", de: "Lincoln" },
      { pl: "Nevada", de: "Carson City" },
      { pl: "New Hampshire", de: "Concord" },
      { pl: "New Jersey", de: "Trenton" }
    ]
  }
];

const ZDANIA153_4 = [
  {
    name: "USA – States and capitals – Part 4",
    lang: "en",
    zdania: [
      { pl: "New Mexico", de: "Santa Fe" },
      { pl: "New York", de: "Albany" },
      { pl: "North Carolina", de: "Raleigh" },
      { pl: "North Dakota", de: "Bismarck" },
      { pl: "Ohio", de: "Columbus" },
      { pl: "Oklahoma", de: "Oklahoma City" },
      { pl: "Oregon", de: "Salem" },
      { pl: "Pennsylvania", de: "Harrisburg" },
      { pl: "Rhode Island", de: "Providence" },
      { pl: "South Carolina", de: "Columbia" }
    ]
  }
];

const ZDANIA153_5 = [
  {
    name: "USA – States and capitals – Part 5",
    lang: "en",
    zdania: [
      { pl: "South Dakota", de: "Pierre" },
      { pl: "Tennessee", de: "Nashville" },
      { pl: "Texas", de: "Austin" },
      { pl: "Utah", de: "Salt Lake City" },
      { pl: "Vermont", de: "Montpelier" },
      { pl: "Virginia", de: "Richmond" },
      { pl: "Washington", de: "Olympia" },
      { pl: "West Virginia", de: "Charleston" },
      { pl: "Wisconsin", de: "Madison" },
      { pl: "Wyoming", de: "Cheyenne" }
    ]
  }
];

const ZDANIA160 = [
  {
    name: "Français – Kartka 1 – Pozdrowienia i zwroty grzecznościowe",
    lang: "fr",
    zdania: [
      { pl: "dzień dobry", de: "bonjour" },
      { pl: "cześć", de: "salut" },
      { pl: "jak się pan/pani ma?", de: "comment allez-vous ?" },
      { pl: "bardzo dobrze", de: "très bien" },
      { pl: "nieźle", de: "pas mal" },
      { pl: "mam się dobrze", de: "ça va bien" },
      { pl: "źle się mam / nie mam się dobrze", de: "ça va mal" },
      { pl: "tak sobie", de: "comme ci, comme ça" },
      { pl: "a pan/pani?", de: "et vous ?" },
      { pl: "jak się masz? / jak leci?", de: "ça va ?" },
      { pl: "miło mi / miło mi poznać", de: "enchanté(e)" },
      { pl: "ja też", de: "moi aussi" },
      { pl: "a ty?", de: "et toi ?" },
      { pl: "do widzenia", de: "au revoir" },
      { pl: "miłego dnia", de: "bonne journée" },
      { pl: "miłego popołudnia", de: "bon après-midi" },
      { pl: "miłego wieczoru", de: "bonne soirée" },
      { pl: "dobranoc", de: "bonne nuit" },
      { pl: "do jutra", de: "à demain" }
    ]
  }
];

const ZDANIA161 = [
  {
    name: "Français – Kartka 2 – Przedstawianie się",
    lang: "fr",
    zdania: [
      { pl: "przedstawiać się", de: "se présenter" },
      { pl: "jak masz na imię?", de: "comment tu t'appelles ?" },
      { pl: "mam na imię…", de: "je m'appelle…" },
      { pl: "nazywam się…", de: "mon nom est…" },
      { pl: "moje imię to…", de: "mon prénom est…" },
      { pl: "ile masz lat?", de: "tu as quel âge ?" },
      { pl: "mam 15 lat", de: "j'ai quinze ans" },
      { pl: "mam 14 lat", de: "j'ai quatorze ans" },
      { pl: "gdzie mieszkasz?", de: "où habites-tu ?" },
      { pl: "mieszkam we Wrocławiu", de: "j'habite à Wrocław" },
      { pl: "jaka jest twoja narodowość?", de: "quelle est ta nationalité ?" },
      { pl: "jestem Polakiem", de: "je suis polonais" },
      { pl: "jestem Polką", de: "je suis polonaise" },
      { pl: "jesteśmy", de: "nous sommes" },
      { pl: "jesteście / są państwo", de: "vous êtes" },
      { pl: "oni są", de: "ils sont" },
      { pl: "one są", de: "elles sont" }
    ]
  }
];

export {
  ZDANIA140,
  ZDANIA150,
  ZDANIA151,
  ZDANIA152,
  ZDANIA153,
  ZDANIA153_1,
  ZDANIA153_2,
  ZDANIA153_3,
  ZDANIA153_4,
  ZDANIA153_5,
  ZDANIA160,
  ZDANIA161
};
